import React, { FC } from 'react';

import { TableCell } from '@material-ui/core';

import { secondsToHms } from '../../../../../utils/helpers';
import { CellProps } from '../../../const';

const SecondsCell: FC<CellProps> = ({ row, k, styles, align }) => {
  return (
    <TableCell key={k} className={styles.contentCell} align={align}>
      {secondsToHms(row[k])}
    </TableCell>
  );
};

export default SecondsCell;
